import { render, staticRenderFns } from "./ExpandItemDialog.vue?vue&type=template&id=1caedb3a&"
import script from "./ExpandItemDialog.vue?vue&type=script&lang=js&"
export * from "./ExpandItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports